import './overrides/editform/utils';
import components from './components';
// @ts-ignore
import providers from './providers';
export default {
    components: components,
    providers: providers,
};
